import {Component, effect} from '@angular/core';
import {NavigationStart, Router} from '@angular/router';
import {MatDialog} from '@angular/material/dialog';
import {MarkdownService} from './shared/helpers/markdown.service';
import {MapAudioIntegrationService} from './services/map-audio-integration.service';
import {SettingsService} from './api/services/setting.service';
import {installPinchZoomGuard} from './shared/helpers/pinch-zoom.guard';

@Component({
  selector: 'maporium-workspace-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent{
  constructor(private markdownService: MarkdownService,
              private mapAudioIntegrationService: MapAudioIntegrationService,
              private router: Router,
              private settingsService: SettingsService,
              private dialog: MatDialog) {
    this.markdownService.enableMarkdown();
    installPinchZoomGuard();
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.dialog.closeAll();
      }
    });

    // Tooltip settings: drive global tooltip behaviour from the stored prefs.
    // settingsSignal updates on every save (and on boot), so this reacts live.
    // Both default ON — only an explicit `false` turns the feature off.
    effect(() => {
      const settings = this.settingsService.settingsSignal()
        ?? this.settingsService.getLocalStorageSettings();
      document.body.classList.toggle('tooltips-off', settings.tooltipsEnabled === false);
      document.body.classList.toggle('tooltips-fade', settings.tooltipFadingEnabled !== false);
    });
  }
}
